import { useEffect, useState } from "react"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import DynamicSquaredFilterBar from "../../../common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow"
import LoanOverview from "./LoanOverview/LoanOverview"
import LoanManagementTable from "./LoanManagementTable/LoanManagementTable"
import Repayment from "./Repayment/Repayment"
import LoanDetail from "./LoanDetail/LoanDetail"

const LoanManagement = () => {
  const tabs = [
    { key: "loanOverview", label: "Loan Overview" },
    { key: "loanManagement", label: "Loan Management" },
    { key: "repayment", label: "Repayment" },
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  const [showLoanDetail, setShowLoanDetail] = useState(false)

  const statsData = [
    { title: "Total Applications".toUpperCase(), value: 0 },
    { title: "Pending Approvals".toUpperCase(), value: 0 },
    { title: "Approved Loans".toUpperCase(), value: 0 },
    { title: "Rejected Loans".toUpperCase(), value: 0 },
    { title: "Overdue Loans".toUpperCase(), value: 0 },
  ]

  useEffect(()=>{setShowLoanDetail(false)},[activeTab])

  return (
    <LightGrayBgWrapper>
      <div className="shadow">
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="white" />
      </div>

      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="fw-semibold fs-5 mb-3">Overview</div>
        <DynamicCardRow cards={statsData} />
      </div>

      {!showLoanDetail ? (
        <>
          {activeTab === "loanOverview" && <LoanOverview />}
          {activeTab === "loanManagement" && <LoanManagementTable />}
          {activeTab === "repayment" && <Repayment onClick={setShowLoanDetail} />}
        </>
      ) : (
        <LoanDetail setShowLoanDetail={setShowLoanDetail} />
      )}
    </LightGrayBgWrapper>
  )
}

export default LoanManagement
